import { InternalTitle } from 'BaseDataTypes';
import { User } from 'BaseDataTypes';
export interface Course {
  id: number;
  name: string;
  description: string;
  courseLink: string;
  yearsValid: number;
  courseCategoryId: number;
  courseCategory?: CourseCategory;
}
export interface CourseCategory {
  id: number;
  name: string;
}
export interface CourseParticipant {
  id: number;
  userId: number;
  courseId: number;
  course?: Course;
  user?: User;
  courseProgresses: CourseProgress[];
  courseStatusId?: number;
}

export interface certificateFile {
  certificate: string; 
  certificateContentType: string;
}

export interface CourseProgress {
  id: number;
  courseParticipantId: number;
  certificate?: string;
  statusDateTime: Date;
  deadline: Date;
  enrollmentDate: Date;
  completionDate?: Date;
  expiryDate?: Date;
  CourseParticipant?: CourseParticipant;
  certificateContentType?: string;
  courseProgressName: CourseProgressNameType;
}

export enum CourseProgressNameType {
  Enrolled = 'Enrolled',
  Completed = 'Completed',
  Expired = 'Expired',
}

/**
 * Translations for CourseProgressNameType to danish text value
 */
export const CourseProgressTranslations: {
  [key in CourseProgressNameType]: string;
} = {
  [CourseProgressNameType.Enrolled]: 'Tilmeldt',
  [CourseProgressNameType.Completed]: 'Gennemført',
  [CourseProgressNameType.Expired]: 'Udløbet',
};

export const SelectableCourseProgressNameType = {
  Enrolled: CourseProgressNameType.Enrolled,
  Completed: CourseProgressNameType.Completed,
};

export class CourseProgressComponent {
  courseProgressNameType = CourseProgressNameType;
  selectableCourseProgressNameType = SelectableCourseProgressNameType;
}

export interface UserParticipant extends User {
  participating: boolean;
}

export interface CourseEvent {
  id: number;
  userId: number;
  date: Date;
  eventPage?: string;
  eventObjectId: number;
  eventAction?: string;
  eventMessage?: string;
}
